export default __webpack_public_path__ + "static/media/1959.998c113a.png";